import { ApplicationConfig } from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { routes } from "./app.routes";
import { SupabaseService } from "./services/supabase.service";
import { OpenAIBaseService } from "./services/open-ai-base.service";
import { JobParserService } from "./services/job-parser.service";
import { ResumeAnalyzerService } from "./services/resume-analyzer.service";
import { PortfolioService } from "./services/portfolio.service";
import { ProfileCompletenessService } from "./services/profile-completeness.service";
import { LocationIntelligenceService } from "./services/location-intelligence.service";
import { provideClientHydration } from "@angular/platform-browser";
import { AuthService } from "./services/auth.service";
import { ResumeProcessingService } from "./services/resume-processing.service";
import { JobMatcherService } from "./services/job-matcher.service";
import { authInterceptor } from "./services/auth.interceptor";
import { PaginationPreloaderService } from "./services/pagination-preloader.service";
import { StripeService } from "./services/stripe.service";
import { JobCategoryService } from "./services/job-category.service";
import { SubscriptionService } from "./services/subscription.service";
import { DailyQuotesService } from "./services/daily-quotes.service";
import { OgImageService } from "./services/og-image.service";
import { UsageLimitService } from "./services/usage-limit.service";
import { DocumentValidationService } from "./services/document-validation.service";
import { ResumeJobAnalyzerService } from "./services/resume-job-analyzer.service";
import { AIChatService } from "./services/ai-chat.service";
import { CalibrationService } from "./services/calibration.service";
import { EmbeddingService } from "./services/embedding.service";
import { SemanticJobSearchService } from "./services/semantic-job-search.service";
import { ToastService } from "./services/toast.service";
import { FeedbackService } from "./services/feedback.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      // Removed PreloadAllModules - now routes load only when needed
      // This dramatically reduces initial bundle size
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
        anchorScrolling: "enabled",
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideClientHydration(),
    SupabaseService,
    OpenAIBaseService,
    JobParserService,
    ResumeAnalyzerService,
    PortfolioService,
    ProfileCompletenessService,
    LocationIntelligenceService,
    AuthService,
    ResumeProcessingService,
    JobMatcherService,
    PaginationPreloaderService,
    StripeService,
    JobCategoryService,
    SubscriptionService,
    DailyQuotesService,
    OgImageService,
    UsageLimitService,
    DocumentValidationService,
    ResumeJobAnalyzerService,
    AIChatService,
    CalibrationService,
    EmbeddingService,
    SemanticJobSearchService,
    ToastService,
    FeedbackService,
  ],
};
